import * as React from 'react'
import { Button } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import Footer from 'components/Footer'
import Header from 'components/Header'
import loginData from 'utilities/loginData'

const SceneComponent: React.FC = () => {
  const navigate = useNavigate()
  React.useEffect(() => {
    if (!loginData.isLoggedIn()) {
      navigate('/')
    }
  }, [navigate])
  return (
    <>
      <Header title="証明書アップロード完了" />
      <main>
        <section className="mx-4 my-5">
          <div className="mt-5">
            <p>現在、弊社で法人登録の内容確認のためお時間をいただいております。</p>
            <p>確認が終了いたしましたら結果をメールにてご連絡させていただきます。</p>
            <p>その後の手続きがございますのでご確認ください。</p>
          </div>
          <div className="mt-5">
            <Button variant="primary" className="w-100 py-4" href={'/login'}>
              ログイン画面へ戻る
            </Button>
          </div>
        </section>
      </main>
      <Footer className="mt-5" />
    </>
  )
}

export default SceneComponent
